(function () {
    'use strict';

    angular.module("imApp").factory("languageEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3347,
                    parameters: parms || {}
                });
            },
            listDateFormats: function (parms) {
                return $ihttp.post({
                    method: 3348,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3349,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
